if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Carrossel (07/10/2026): uma foto por vez; arrastar no celular, setas e teclado no desktop.
        this.track = this.querySelector('.product-media-modal__content');
        this.prevButton = this.querySelector('[data-lightbox-prev]');
        this.nextButton = this.querySelector('[data-lightbox-next]');
        this.currentLabel = this.querySelector('[data-lightbox-current]');
        this.totalLabel = this.querySelector('[data-lightbox-total]');

        [this.prevButton, this.nextButton].forEach((button, index) => {
          if (!button) return;
          button.addEventListener('click', () => this.go(index === 0 ? -1 : 1));
          // O ModalDialog fecha o lightbox em qualquer pointerup de mouse: as setas não podem fechar.
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(-1, true);
          if (event.key === 'ArrowRight') this.go(1, true);
        });

        if (this.track) {
          this.track.addEventListener('scroll', () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.updateCounter();
            });
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get slides() {
        return this.track ? Array.from(this.track.children) : [];
      }

      currentIndex() {
        if (!this.track || !this.track.clientWidth) return 0;
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      // Teclado sem animação; setas com rolagem suave (exceto com "reduzir movimento").
      go(step, instant) {
        if (!this.track) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const index = Math.min(Math.max(this.currentIndex() + step, 0), this.slides.length - 1);
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth' });
      }

      updateCounter() {
        const total = this.slides.length;
        const index = this.currentIndex();
        if (this.currentLabel) this.currentLabel.textContent = index + 1;
        if (this.totalLabel) this.totalLabel.textContent = total;
        if (this.prevButton) this.prevButton.disabled = index <= 0;
        if (this.nextButton) this.nextButton.disabled = index >= total - 1;
        this.classList.toggle('bm-lightbox--single', total < 2);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // Abre direto na foto tocada, sem animação.
        if (this.track) {
          const slide = activeMedia.closest('.bm-lightbox__slide') || activeMedia;
          const index = Math.max(this.slides.indexOf(slide), 0);
          this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'auto' });
        }
        this.updateCounter();
        if (this.track) this.track.focus({ preventScroll: true });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
